import React from 'react';
import {AppBar, Toolbar, Typography, Container, IconButton} from '@mui/material';
import {useTranslation} from "react-i18next";
import AuthenticationProfile from "../AuthenticationProfile";
import LanguageIcon from '@mui/icons-material/Language';

function TopBar() {
    const {i18n} = useTranslation();
    const toggleLanguage = () => {
        const newLang = i18n.language === 'en' ? 'fr' : i18n.language === 'fr' ? 'nl' : 'en';
        i18n.changeLanguage(newLang).then();
    };

    return (
        <AppBar position="absolute" sx={{width:100, background: 'transparent', boxShadow: 'none', color: 'black', zIndex: 1300}}>
            <Container maxWidth="lg">
                <Toolbar sx={{justifyContent: 'right', alignItems: 'center'}}>
                    <IconButton
                        onClick={toggleLanguage}
                        color="primary"
                        sx={{display: 'flex', alignItems: 'center', gap: 1}}
                        data-testid="language-toggle-button"
                    >
                        <LanguageIcon/>
                        <Typography variant="body2" sx={{textTransform: 'uppercase'}}>
                            {i18n.language || 'en'}
                        </Typography>
                    </IconButton>
                    <AuthenticationProfile/>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default TopBar;
